import type { ComponentProps } from "react"
import ViewSheet from "@/v2-backoffice-client/components/viewSheet"
import { TooltipLink } from "@/v2-backoffice-client/components/link"
import type { LicenseChange } from "@/v2-backoffice-client/license/changes/license.changes.utils"
import { IS_TRANSLATION_ENABLED } from "@/v2-backoffice-client/translation/translation.constants"
import {
  deriveCategory,
  getTranslationCategoryHref,
} from "@/v2-backoffice-client/translation/translation.utils"

export type LicenseCapabilityViewToolbarProps = ComponentProps<"div"> & {
  change: LicenseChange | null | undefined
}

// The one thing about a capability that is edited elsewhere in Backoffice:
// its name and description are text rows on the Features page (where
// v2-features-db is reachable; the page is dev-only). Who has it is decided
// right here, and everything else about it is a code change.
function LicenseCapabilityViewToolbar(
  props: LicenseCapabilityViewToolbarProps,
) {
  const { change, ...viewSheetToolbarProps } = props
  if (!change || !IS_TRANSLATION_ENABLED) return null

  return (
    <ViewSheet.Toolbar {...viewSheetToolbarProps}>
      <TooltipLink
        variant="ghost"
        isStacked
        iconSrc="edit"
        content="Edit the capability's name and description: they are text rows on the Features page, under this code's category"
        to={getTranslationCategoryHref(deriveCategory(change.SurfaceCode))}
        data-feature-code="UI_BackofficeWhatsNew_Panel_EditText"
      >
        Text
      </TooltipLink>
    </ViewSheet.Toolbar>
  )
}

export default LicenseCapabilityViewToolbar
